module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_5.81a2cf14.svg";